/** Console v0.5 Organisations: session A's routes (#386, contracts s.17). Scope is the caller's own; anything else is
 * the same 404 as an unknown id. Adding is for an account admin who sees every organisation, under the limit. */

import { apiRequest } from "../api.js";
import type { Service } from "./items-api.js";

export interface OrgRow {
  organisation_id: string;
  name: string;
  abn: string | null;
  xero: { connected: boolean };
  status: string | null; // the most urgent work the person can see, or null
  open_items: number;
}

export interface OrgList {
  type: "practice" | "company" | null;
  organisations: OrgRow[];
  limits: { organisations: { used: number; max: number } | null };
  can_add: boolean;
}

export function fetchOrganisations(q = ""): Promise<OrgList> {
  const qs = q.trim() ? `?q=${encodeURIComponent(q.trim())}` : "";
  return apiRequest("GET", `/api/organisations${qs}`, "Preekie couldn't load the organisations.");
}

export function fetchOrganisation(id: string): Promise<{ organisation: OrgRow & { services: Array<{ service: Service; open: number }> } }> {
  return apiRequest("GET", `/api/organisations/${encodeURIComponent(id)}`, "Preekie couldn't load this organisation.");
}

export function addOrganisation(name: string, abn: string): Promise<{ organisation: OrgRow }> {
  const body: { name: string; abn?: string } = { name: name.trim() };
  if (abn.trim()) body.abn = abn.replace(/\s/g, "");
  return apiRequest("POST", "/api/organisations", "The organisation wasn't added.", body);
}

export function setPinned(organisationIds: string[]): Promise<{ pinned_organisations: Array<{ organisation_id: string; name: string }> }> {
  return apiRequest("POST", "/api/me/pinned", "Pinned organisations weren't saved.", { organisation_ids: organisationIds });
}
